<template>
  <div class="overlay">
    <div class="modal">
      <div class="modal__title">
        <span>Session Expired</span>
      </div>
      <div class="p-3">
     <v-card>
        <v-card-title class="headline grey lighten-2">
            Session Expired 
      </v-card-title>
        <v-card-text>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="navigate()"
          >
           Okay
          </v-btn>
        </v-card-actions>
      </v-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
      methods: {
      navigate(){
          //clear catch
        this.$router.push({name: "home"})
        this.$store.commit('setUser', null)
      }
    }, 
}
</script>

<style lang="postcss" scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  width: 500px;
  box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12);
  border-radius: 4px;
  @apply bg-white p-2;
}

.modal__title {
  color: #38404f;
  @apply flex items-center justify-between p-3 font-bold;
}
</style>